var map = {
	"./en.js": "8dcc",
	"./ja.js": "b7e3",
	"./km.js": "aa99",
	"./ko.js": "c2eb",
	"./lo.js": "6a09",
	"./vi.js": "3ca7",
	"./zh.js": "175f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8726";